import { FixedSizeVirtualScrollStrategy } from '@angular/cdk/scrolling';
import { defaultBeneficiaryCdkScrollConfig } from '../constants/beneficiary-scroll-config';

export class BeneficiaryScrollStrategyService extends FixedSizeVirtualScrollStrategy {
  constructor() {
    const { itemSize, minBufferPx, maxBufferPx } = defaultBeneficiaryCdkScrollConfig;
    super(itemSize, minBufferPx, maxBufferPx);
  }
}
